import { createStore, combineReducers } from "redux";

import userReducer from "./reducers/UserReducer";
import cardReducer from "./reducers/CardReducer";
import transactionsReducer from "./reducers/TransactionReducer";
import charityReducer from "./reducers/CharityReducer";
import partnerReducer from "./reducers/PartnerReducer";
import uiStateReducer from "./reducers/UIStateReducer";
import investReducer from "./reducers/InvestReducer";
import notificationReducer from "./reducers/NotificationReducer";
import offerReducer from "./reducers/OfferReducer";

const rootReducer = combineReducers({
  user: userReducer,
  card: cardReducer,
  transaction: transactionsReducer,
  charity: charityReducer,
  partners: partnerReducer,
  uistate: uiStateReducer,
  invest: investReducer,
  notifications: notificationReducer,
  offers: offerReducer
});

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;
